import React, {createContext, useContext} from 'react'
import { useSelector} from 'react-redux'
import PhotoGallery from "src/shared/widgets/photo_gallery"
import {Liquid} from 'liquidjs'
import {useTracking} from "../effects/use_tracking";
import IframeResizer from "iframe-resizer-react";
import moment from 'moment';
import Countdown from "react-countdown";
import DangerousHtmlRenderer from 'src/shared/service/dangerous_html_renderer'
import DirectMessaging from "./direct_messaging/direct_messaging";
import JSON5 from "json5"
import Voting from "../../video/video_room/widgets/components/voting";
import QuestionForm from "../../video/video_room/widgets/components/question_form";
import Gauge from "./gauge/gauge";
import {useUnreadMessages} from "./direct_messaging/utils";
import parse, {attributesToProps, domToReact} from 'html-react-parser'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import Carousel from 'react-bootstrap/Carousel'
import uuidv1 from 'uuid/v1'
import Wordcloud from "../../widgets/wordcloud";
import ShareButtons from "./common/share_buttons";
import PodcastPlayer from "../../widgets/podcast_player";
import CtrlC from "../../widgets/ctrlc";
import ChatRoulette from "./chat_roulette/chat_roulette";
import CircleCountdown from "../../widgets/circle_countdown";
import useTranslation from "virtual_congress/effects/use_translation";
import PhotoBooth from "../../photo_booth/photo_booth";
import RenderedVideoRoom from "./rendered_html_content/rendered_video_room";
import RenderedBetOption from "./rendered_html_content/rendered_bet_option";
import GroupChat from "./group_chat/group_chat";
import OpenHotspot from "./rendered_html_content/open_hotspot";
import Toggler from "./rendered_html_content/toggler";
import VideoConferenceChat from "./rendered_html_content/video_conference_chat";
import RenderedVideoRoomTabs from "./rendered_html_content/rendered_video_room_tabs";
import WordCloudForm from "./rendered_html_content/word_cloud_form";
import {useImageMap} from "./image_map_provider";
import UnreadSupportChatMessages from "./rendered_html_content/unread_support_chat_messages";
import renderTag from  "./rendered_html_content/additional_tags/render"
import Flavewindhund36522CustomVoting from "./rendered_html_content/flavewindhund36522_custom_voting";
import PageEditor from "../../../admin/page_editor/page_editor";
import RenderedMarker from "./rendered_html_content/rendered_marker";
import RenderedInteractiveSvgWrapper from "./rendered_html_content/rendered_interactive_svg_wrapper";
import {viennaTime} from "./rendered_html_content/additional_filters/vienna_time";
import {TagOwnerSearch} from "./rendered_html_content/tag_owner_search";
import QuestionsUpVoteButton from '../../video/video_room/widgets/components/questions_upvote_button'
import {RenderedPictureMosaic} from "./rendered_html_content/rendered_picture_mosaic";
import {RenderedSelfieUpload} from "./rendered_html_content/rendered_selfie_upload";
import { renderToString } from "react-dom/server";
import {urlParam} from "./rendered_html_content/additional_filters/url_param";
import {getNtranslation} from "./rendered_html_content/additional_filters/get_ntranslation";
import {ZoomPanPinch} from "./rendered_html_content/zoom_pan_pinch";
import {RenderedSwiper} from "./rendered_html_content/rendered_swiper";

const UnreadMessages = () => {
  const unreadMessages = useUnreadMessages()

  if (unreadMessages && unreadMessages.length > 0) {
    return <span>
      {unreadMessages.length}
    </span>
  }

  return null
}

const RenderedPhotoBooth = (props) => {
  const tagOwner = useSelector(state => state.tagOwner)
  const photoBoothConfig = useSelector(state => state.photo_booth_configs)?.find(pbc => pbc.id.toString() === props["data-photo-booth-config-id"])

  return <PhotoBooth
    locale={props["data-photo-booth-locale"]}
    tagOwner={tagOwner}
    photoBoothConfig={photoBoothConfig}/>
}


const CustomRenderedHtmlRendererContext = createContext(null)

export const CustomRenderedHtmlRenderer = ({value, ...props}) => {
  return <CustomRenderedHtmlRendererContext.Provider value={value}>
    {props.children}
  </CustomRenderedHtmlRendererContext.Provider>
}

const useCustomRenderedHtmlContentRenderer = () => {
  return useContext(CustomRenderedHtmlRendererContext)
}


export default function RenderedHtmlContent({html, placeholders, identifier, parseLiquid = true, ...props}) {
  const imageMap = useImageMap()
  const track = useTracking()
  const videoRooms = useSelector(state => state.videoRooms);
  const htmlContents = useSelector(state => state.htmlContents || [])
  const events = useSelector(state => state.events)
  const htmlContent = useSelector(state => state.htmlContents || []).find(item => item.identifier == identifier)
  const isBoothEditor = useSelector(state => state.isBoothEditor)
  const videoConferenceParticipants = useSelector(state => state.groupChat?.participants) || []
  const developers = ["mk@flave.at", "dg@flave.at", "al@flave.at", "pl@flave.at", "tc@flave.at", "gh@flave.at", "sb@flave.at"]
  const t = useTranslation()
  const state = useSelector(state => state)
  const customRenderedHtmlContentRenderer = useCustomRenderedHtmlContentRenderer()

  if (htmlContent && htmlContent.editor_type === 'react_page_editor') {
    return <PageEditor htmlContentId={htmlContent.id} readOnly={true}/>
  }

  if (identifier && htmlContent && !html) {
    html = htmlContent.html
  }

  if (html == null) {
    html = "";
  }
  const tagOwner = useSelector(state => state.tagOwner)

  if (!placeholders) {
    placeholders = {}
  }

  if (props.children) {
    let c = props.children
    let reactC = domToReact(props.children);

    placeholders.yield = c;
    placeholders.yield_v2 = reactC;
    placeholders.identifier = identifier;
  }

  if (tagOwner) {
    if (!placeholders.tagOwner) {
      placeholders.tagOwner = tagOwner
    }
    if (!placeholders.tag_owner) {
      placeholders.tag_owner = tagOwner
    }
  }

  if (!placeholders.imageMap) {
    placeholders.imageMap = imageMap
  }

  if (!placeholders.events) {
    placeholders.events = events
  }

  if (!placeholders.htmlContents) {
    placeholders.htmlContents = htmlContents
  }

  if (placeholders?.tagOwner?.id) {
    html = String(html).replace(/@tag_owner_id@/g, placeholders.tagOwner.id)
  }

  placeholders.videoConferenceParticipants = videoConferenceParticipants

  // placeholders have higher priority than state, just to ensure backward compability
  placeholders = Object.assign({}, state, placeholders)

  placeholders.current_hash = window.location.hash


  //console.log({ placeholders, html })
  const engine = new Liquid()
  engine.registerTag("render_html", renderTag)
  engine.registerFilter("vienna_time", viennaTime)
  engine.registerFilter("url_param", urlParam)
  engine.registerFilter("get_ntranslation", getNtranslation)

  if (parseLiquid) {
    try {
      //const tpl = engine.parse(html)
      html = engine.parseAndRenderSync(html, placeholders)
    } catch (ex) {
      console.error(ex, "placeholders", placeholders, html)
    }
  }
  //console.log({htmlContent, html})

  let content = null

  try {
    const options = {
      htmlparser2: {
        lowerCaseTags: false
      },
      replace: (node) => {
        // import { CustomRenderedHtmlRenderer } from 'src/shared/virtual_congress/components/rendered_html_content'
        // <CustomRenderedHtmlRenderer value={(node) => { if(node...) { return <...> } else { return null }}}>

        let renderedCustomContent = null
        if (customRenderedHtmlContentRenderer) {
          renderedCustomContent = customRenderedHtmlContentRenderer.call(this, node)
          if (renderedCustomContent) {
            return renderedCustomContent
          }
        }

        if(node.attribs && node.attribs.role == "yield") {
          console.log("YIELD ", node, placeholders.yield);
          //debugger
          let stringHtmlCode = renderToString(<>{props.children}</>)

          return <RenderedHtmlContent {...props} placeholders={placeholders} html={stringHtmlCode}>
            {domToReact(node.children)}
          </RenderedHtmlContent>
        }

        if (node.name === 't' || node.name === 'translation') {
          return t(node.attribs.key)
        }

        if (node.attribs?.role === "unread-support-chat-messages") {
          return <UnreadSupportChatMessages
            ignoreCompletedSessions={node.attribs["data-ignore-completed-sessions"] === "true"}
          />
        }

        if (node.attribs && node.attribs.role == "language-check" && node.attribs["data-language"]) {
          if (tagOwner?.language == node.attribs["data-language"]) {
            return node
          } else {
            return <></>
          }
        }
        if (node.type === 'tag' && node.name.toString().toLowerCase() == "iframe" && node.attribs.role != "no-auto-resize") {
          console.log("Rendering iframe", attributesToProps(node.attribs))
          return <IframeResizer {...attributesToProps(node.attribs)} />
        }
        if (node.attribs && node.attribs.role == "countdown-circle") {
          return <CircleCountdown {...attributesToProps(node.attribs)}/>
        }
        if (node.attribs?.role === "bet-answer") {
          return <RenderedBetOption node={node} options={options}/>
        }
        if (node.attribs?.toggles) {
          return <Toggler node={node} options={options}/>
        }
        if (node.attribs?.role === "marker") {
          return <RenderedMarker node={node} options={options}/>
        }
        if (node.attribs?.role === "tag-owner-search") {
          return <TagOwnerSearch node={node} options={options}/>
        }
        if (node.attribs?.role === "interactive-svg-wrapper") {
          return <RenderedInteractiveSvgWrapper node={node} options={options}/>
        }
        if (node.attribs?.role === "zoom-pan-pinch") {
          return <ZoomPanPinch node={node} options={options}/>
        }
        if (node.attribs?.role === "swiper") {
          return <RenderedSwiper node={node} options={options}/>
        }
        if (node.attribs?.role === "open-hotspot") {
          return <OpenHotspot node={node} options={options} onClick={props.handleHotspotClick}/>
        }
        if (node.attribs && node.attribs.role == "countdown" && node.attribs["data-target-time"] && moment.parseZone(node.attribs["data-target-time"]).isValid()) {
          const props = attributesToProps(node.attribs);
          try {
            if (node.attribs["data-renderer"]) {
              let renderer = new Function("props", node.attribs["data-renderer"]);
              console.log("Rendering custom countdown")
              return (
                <>
                  <Countdown renderer={renderer} date={moment.parseZone(node.attribs["data-target-time"]).toDate()}>
                    <>
                      {domToReact(node.children)}
                    </>
                  </Countdown>
                  {props.children}
                </>
              )
            } else {
              console.log("rendering normal countdown", node.children)
              return <>
                <Countdown date={moment.parseZone(node.attribs["data-target-time"]).toDate()}>
                  <>
                    {domToReact(node.children)}
                  </>
                </Countdown>
                {props.children}
              </>
            }
          } catch (e) {
            console.error(e)
          }
        }
        if (node.attribs && (node.attribs.role == "html-content" || node.attribs.role == "html_content")) {
          let htmlContent = null
          if (node.attribs["data-id"]) {
            htmlContent = htmlContents.find(hc => hc.id == node.attribs["data-id"])
          } else if (node.attribs["data-identifier"]) {
            htmlContent = htmlContents.find(hc => hc.identifier == node.attribs["data-identifier"])
          } else {
            console.error("No attribute found for either data-id nor data-identifier", node)
          }
          return <RenderedHtmlContent {...props} placeholders={placeholders} html={htmlContent?.html}>
            {domToReact(node.children)}
          </RenderedHtmlContent>
        }
        if (node.attribs && node.attribs.role == "trackable") {
          const props = attributesToProps(node.attribs);
          if (!node.attribs["data-tracking-source"] && !node.attribs["data-source"]) {
            console.error("NO TRACKING SOURCE PROVIDED!!!")
            if (tagOwner && developers.indexOf(tagOwner.email) >= 0) {
              alert("NO TRACKING SOURCE PROVIDED!!!")
              return <div className="alert alert-danger">
                No tracking source provided!<br/>
                {domToReact(node.children)}
              </div>
            }
          }
          const CustomTag = node.name

          const trackingData = {
            description: node.attribs["data-tracking-description"] || node.attribs["data-description"],
            identifier: node.attribs["data-tracking-identifier"] || node.attribs["data-identifier"],
            string_linked_item_type: node.attribs["data-string-linked-item-type"],
            string_linked_item_id: node.attribs["data-string-linked-item-id"],
            linked_item_type: node.attribs["data-linked-item-type"],
            linked_item_id: node.attribs["data-linked-item-id"]
          }

          return <CustomTag datarenderedtype="tracked_link" {...props}
                            onClick={() => track(node.attribs["data-tracking-source"] || node.attribs["data-source"] || 'no-source-provided', trackingData, {event_label: node.attribs["data-tracking-identifier"] || node.attribs["data-identifier"]})}>
            {domToReact(node.children)}
          </CustomTag>
        }
        if (node.attribs && node.attribs.role == "photo-gallery") {
          return <PhotoGallery {...attributesToProps(node.attribs)}/>
        }

        if (node.attribs && (node.attribs.role == "word_cloud" || node.attribs.role == "wordcloud")) {
          return <Wordcloud {...attributesToProps(node.attribs)} />
        }

        if (node.attribs && (node.attribs.role == "word_cloud_form" || node.attribs.role == "wordcloudform")) {
          return <WordCloudForm {...attributesToProps(node.attribs)} />
        }

        if (node.attribs && (node.attribs.role === "video-conference-chat")) {
          return <VideoConferenceChat videoConferenceId={node.attribs["data-video-conference-id"]}
                                      videoConferenceIdentifier={node.attribs["data-video-conference-identifier"]}/>
        }

        if (node.attribs && node.attribs.role == "podcast-player") {
          return <PodcastPlayer {...attributesToProps(node.attribs)} />
        }

        if (node.attribs && node.attribs.role == "photo-booth") {
          return <RenderedPhotoBooth {...attributesToProps(node.attribs)} />
        }

        if (node.attribs && node.attribs.role == "flavewindhund365-custom-votings") {
          return <Flavewindhund36522CustomVoting />
        }

        if (node.attribs && (node.attribs.role == "video_room" || node.attribs.role == "video-room")) {
          return <RenderedVideoRoom
            node={node}
            options={options}
          />
        }

        if (node.attribs && (node.attribs.role == "video_room_tabs" || node.attribs.role == "video-room-tabs")) {
          console.log("options", options);
          return <RenderedVideoRoomTabs
            node={node}
            options={options}
          />
        }

        if (node.attribs && node.attribs.role == "direct-messaging") {
          return <DirectMessaging
            disableBackButton={node.attribs["data-hide-back-button"] === "true"}
            preselectedTagOwnerId={node.attribs["data-preselected-tag-owner-id"]}
            initialShowParticipants={node.attribs["data-show-participants"] === "true"}
          />
        }

        if (node.attribs && node.attribs.role == "unread-direct-messages") {
          if (isBoothEditor) {
            return <span>-</span>
          }
          return <UnreadMessages/>;
        }

        if (node.attribs && node.attribs.as == "tabs") {
          return <Tabs {...attributesToProps(node.attribs)}>
            {domToReact(node.children, options)}
          </Tabs>
        }

        if (node.attribs && node.attribs.as == "tab") {
          const eventKey = uuidv1()
          return <Tab eventKey={eventKey} title={node.attribs.title} {...attributesToProps(node.attribs)}>
            {domToReact(node.children, options)}
          </Tab>
        }

        if (node.attribs && node.attribs.role == "accordion") {
          return <Accordion {...attributesToProps(node.attribs)} >
            <Card>
              {domToReact(node.children, options)}
            </Card>
          </Accordion>
        }

        if (node.attribs && node.attribs.role == "ctrl+c") {
          return <CtrlC node={node} {...attributesToProps(node.attribs)} >
            {domToReact(node.children, options)}
          </CtrlC>
        }

        if (node.attribs && node.attribs.role == "accordionContent") {
          const eventKey = uuidv1()
          return <>
            <Accordion.Toggle as={Card.Header} eventKey={eventKey}>
              {node.attribs.title}
            </Accordion.Toggle>

            <Accordion.Collapse eventKey={eventKey}>
              <Card.Body>{domToReact(node.children, options)}</Card.Body>
            </Accordion.Collapse>
          </>
        }

        if (node.attribs && node.attribs.role == "carousel") {
          return <Carousel {...attributesToProps(node.attribs)}>
            {domToReact(node.children, options)}
          </Carousel>
        }

        if (node.attribs && node.attribs.role == "share-button") {
          return <ShareButtons
            shareUrl={node.attribs["data-url"]}
            shareTitle={node.attribs["data-share-title"]}
            shareText={node.attribs["data-share-text"]}
            disableNavigatorShare={node.attribs["data-disable-navigator-share"]}
            mobileShareButtonImage={node.attribs["data-tracking-source"]}
            trackingSource={node.attribs["data-tracking-source"] || "link-shared"}
          />
        }

        if (node.attribs && node.attribs.role == "carouselPage") {
          return <Carousel.Item {...attributesToProps(node.attribs)}>
            <img className="d-block w-100" src={node.attribs.src} alt=""/>
            <Carousel.Caption>{domToReact(node.children, options)}</Carousel.Caption>
          </Carousel.Item>
        }


        if (node.attribs && node.attribs.role == "gauge") {
          return <Gauge
            defaultGaugeValue={node.attribs["clapping"] ? (parseInt(node.attribs["clapping"], 10) / 100) : 0.0}
          />
        }


        if (node.attribs && node.attribs.role === "chat-roulette") {
          return <ChatRoulette/>
        }

        if (node.attribs && node.attribs.role === "video-conference-group-chat") {
          return <GroupChat videoConferenceIdentifier={node.attribs["data-video-conference-identifier"]}/>
        }

        if (node.attribs && node.attribs.role === "video-conference-participants") {
          return <VideoConferenceParticipants node={node} options={options}/>
        }

        if (node.attribs && node.attribs.role == "voting") {
          const videoRoom = videoRooms.find(videoRoom => node.attribs["video-room-id"] ? videoRoom.id == node.attribs["video-room-id"] : (node.attribs["data-video_room_identifier"] ? videoRoom.id == node.attribs["data-video_room_identifier"] : null))

          if (!videoRoom) {
            return <div className="alert alert-danger">
              VIDEO ROOM NOT FOUND
            </div>
          }

          let votingOptions = {}
          if (node.attribs["voting-options"]) {
            try {
              votingOptions = JSON5.parse(node.attribs["voting-options"])
            } catch (e) {
              console.error("Error while parsing voting options.", e)
            }
          }

          let votingFormOptions = {}
          if (node.attribs["voting-form-options"]) {
            try {
              votingFormOptions = JSON5.parse(node.attribs["voting-form-options"])
            } catch (e) {
              console.error("Error while parsing voting form options.", e)
            }
          }

          const thankYouText = node.attribs["thank-you-text"]

          return <Voting videoRoom={videoRoom} thankYouText={thankYouText} options={votingOptions}
                         votingFormOptions={votingFormOptions}/>
        }

        if (node.attribs && node.attribs.role == "question_form") {
          const videoRoom = videoRooms.find(videoRoom => node.attribs["video-room-id"] ? videoRoom.id == node.attribs["video-room-id"] : (node.attribs["data-video_room_identifier"] ? videoRoom.identifier == node.attribs["data-video_room_identifier"] : null))

          if (!videoRoom) {
            return <div className="alert alert-danger">
              VIDEO ROOM NOT FOUND
            </div>
          }

          let questionFormOptions = {}
          if (node.attribs["question-form-options"]) {
            try {
              questionFormOptions = JSON5.parse(node.attribs["question-form-options"])
            } catch (e) {
              console.error("Error while parsing question_form options.", e)
            }
          }

          return <QuestionForm videoRoom={videoRoom} options={questionFormOptions}/>
        }

        if (node.attribs && node.attribs.role === "picture-mosaic") {
          return <RenderedPictureMosaic node={node}/>
        }

        if (node.attribs && node.attribs.role === "selfie-upload") {
          return <RenderedSelfieUpload node={node}/>
        }

        if (node.type === 'script') {
          //console.debug("script html", node.children[0]?.data)
          return <DangerousHtmlRenderer
            node={node}
            attribs={node.attribs}
            html={node.children[0]?.data}
            appendToBody={node.attribs["data-append-to-body"] === "true"}
            renderHtml={node.attribs["data-render-html"] !== "false"}
          />
        }

        if (node.attribs && node.attribs.role === "questions-upvote-button"){
          const eventQuestions = useSelector(state => state.eventQuestions || []) 
          const videoRoom = videoRooms.find(videoRoom => videoRoom.id == node.attribs["video-room-id"] || ( node.attribs["data-video_room_identifier"] && videoRoom.identifier == node.attribs["data-video_room_identifier"]))
          const question = eventQuestions.find(question => question.id == node.attribs["question-id"])
          const upVoteUrl = node.attribs["upvoteurl"]
          return <QuestionsUpVoteButton videoRoom={videoRoom} question={question} upVoteUrl={upVoteUrl}/>
        }
      }
    }
    content = parse(html, options)
  } catch (ex) {
    console.log("error html", html)
    content = <div className="alert alert-danger">Please contact the technical support.</div>
    console.error(ex)
  }
  return content

}
